// Underlyings for the Index Option dashboard. Must match Angel One's scrip
// master naming for option-chain resolution to work (see
// UNDERLYING_TO_SYMBOL_PREFIX in backend/engine/instrument_resolver.py).
//
// Note: FINNIFTY and SENSEX aren't tradable yet -- their spot index tokens
// still need to be added to KNOWN_INDEX_TOKENS on the backend (unverified
// in the environment this was built in). They're listed here so the UI is
// ready, but resolving/starting a strategy on either will fail with a
// clear error until that's done. NIFTY 50 and NIFTY BANK are verified and
// work today.

export const INDEX_UNDERLYINGS = ["NIFTY 50", "NIFTY BANK", "FINNIFTY", "SENSEX"];
